module.exports = __webpack_public_path__ + "static/media/dublin_7.a08571f6.png";